/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventvisibilitypublicdescription3Inputs */

const en_eventvisibilitypublicdescription3 = /** @type {(inputs: Eventvisibilitypublicdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone sees it and can check in.`)
};

const de_eventvisibilitypublicdescription3 = /** @type {(inputs: Eventvisibilitypublicdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle sehen sie und können einchecken.`)
};

/**
* | output |
* | --- |
* | "Everyone sees it and can check in." |
*
* @param {Eventvisibilitypublicdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventvisibilitypublicdescription3 = /** @type {((inputs?: Eventvisibilitypublicdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventvisibilitypublicdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventvisibilitypublicdescription3(inputs)
	return de_eventvisibilitypublicdescription3(inputs)
});
export { eventvisibilitypublicdescription3 as "eventVisibilityPublicDescription" }